import { Alert, Button, Card, IconButton, Popover, Zoom } from "@mui/material"
import { motion } from "framer-motion"
import { useLayoutEffect, useState } from "react"
import { MdAttachMoney, MdCancel, MdCheck, MdCreditCard, MdMonetizationOn, MdTouchApp, MdUndo } from "react-icons/md"
import { Spinner } from "../../../componentes/Spinner"
import MenuLateral from "../../../componentes/gerais/Menu"
import TopoMenu from "../../../componentes/gerais/TopoMenu"
import Status from "../../../componentes/uteis/Status"

import { Backdrop } from "@mui/material"
import { useContext, useEffect } from "react"
import { Marcador } from "../../../componentes/servicos/cardServico"
import Refresher from "../../../componentes/uteis/Refresher"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import ServicoAPI from "../../../servicos/ServicoAPI"
import MensagemApp from "../../../servicos/config/MensagemApp.js"
import { configAnim } from "../../../servicos/config/configAnim"

import { AttachMoney, Close, CreditCard, Pix, PointOfSale, Refresh, RssFeed, Subtitles } from "@mui/icons-material"

import { format, isValid, parse } from "date-fns"
import { useRef } from "react"
import CardEndereco from "../../../componentes/form/CardEndereco"
import useTestChecker from "../../../hooks/general/useTestChecker"
import { print, verificarBootClick } from '../../../servicos/Uteis.js'
import AlertDialog, { BootClickAlert, FakeGpsAlert } from "./../../../componentes/gerais/Dialog.jsx"
import { Balloon } from "./styles"

import FakeGPSBlock from "../../../componentes/uteis/FakeGPSBlock"
import CheckPermission from "../../../servicos/config/CheckPermission"
import icon from "./../../../assets/icones/relogio.svg"
import { useLocation } from "react-router-dom"
import {
	BotaoVerRota,
	MapaCotacaoSheet,
	MapaCotacaoView,
	deveExibirMapaCotacao,
	pontosMapaCotacao,
} from "./MapaCotacao"

function formaPg(forma) {
	let icon = <></>

	const sx = { fontSize: "1rem" }

	if (forma.sigla != "-") {

		switch (forma.sigla) {
			case "C":
				icon = <CreditCard sx={sx} />
				break
			case "T":
				icon = <AttachMoney sx={sx} />
				break
			case "L":
				icon = <AttachMoney sx={sx} />
				break
			case "P":
				icon = <PointOfSale sx={sx} />
				break
			case "D":
				icon = <AttachMoney sx={sx} />
				break
			case "S":
				icon = <AttachMoney sx={sx} />
				break
			case "":
			case "F":
				icon = <AttachMoney sx={sx} />
				break
			case "M":
				icon = <PointOfSale sx={sx} />
				break
			case "H":
				icon = <Pix sx={sx} />
		}

		return <div className="flex items-center">
			{icon}
			<p className="mb-0" style={{ marginTop: "0.125rem" }}>{forma.texto}</p>
		</div>
	}
}

function ServicoCardVinculacao({ servico, tipo, configCotacao, dados }) {
	if (!servico) return null
	const isVinculado = tipo === 'vinculado'
	const urgente = servico['s.urgente'] == 'S'
	const economico = servico['s.freteExpresso'] == 'S'
	const enderecos = servico.enderecos && Array.isArray(servico.enderecos) ? servico.enderecos : []
	const exibirSemRetorno = getExibirDistanciaSemRetorno(servico, configCotacao, dados)
	const textoSecundario = textoDistanciaSecundaria(servico, configCotacao, dados)
	return (
		<Card className={`p-2 mb-2 ${isVinculado ? 'border-info border-2' : 'border-success border-2'} ${urgente ? 'text-danger' : ''} ${economico ? 'text-info' : ''}`} style={{ borderStyle: 'solid' }}>
			{urgente && (
				<div className="bg-danger mb-2 pt-2 pb-2 ps-2 pe-2 text-white small rounded">Serviço urgente</div>
			)}
			{economico && !urgente && (
				<div className="bg-info mb-2 pt-2 pb-2 ps-2 pe-2 text-white small rounded">Serviço econômico</div>
			)}
			<div className="flex justify-between items-center">
				<span className="font-bold">#{servico['s.id']}</span>
				{textoSecundario && (
					<div className="flex flex-col align-items-end">
						<div className="font-normal text-sm opacity-75">
							{textoSecundario}
						</div>
					</div>
				)}
			</div>
			<div className="my-1 flex flex-wrap gap-1">
				<div className="flex flex-col">
					{(servico['s.valor'] || servico['s.valorProfissional']) && (
						<div className="mb-0 text-green-600 pb-0">
							<span className="fw-bold">
								{servico['s.valor'] == '-'
									? '-'
									: servico['s.valor']
										? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(servico['s.valor']))
										: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(servico['s.valorProfissional']) || 0)}
							</span>
							{servico.valorPorKm && <div className="text-xs text-success font-normal">Valor por km: R$ {servico.valorPorKm}</div>}
						</div>
					)}
					{servico['metodoPag'] && formaPg(servico['metodoPag'])}
				</div>
				{(() => {
					const distanciaDestaque = servico.destaqueDistancia == 'DV'
						? servico['sm.distanciaColeta']
						: (exibirSemRetorno ? (servico['s.distanciaSemRetorno'] ?? servico['s.distancia']) : servico['s.distancia'])
					if (!distanciaDestaque) return null
					const temSemRetorno = servico.destaqueDistancia !== 'DV' && exibirSemRetorno && !!servico['s.distanciaSemRetorno']
					const label = servico.destaqueDistancia == 'DV'
						? 'Distância de você'
						: (temSemRetorno ? 'Distância do serviço (sem retorno)' : 'Distância do serviço')
					return (
						<div className="text-end ms-auto flex flex-col">
							<span className="fw-bold">{String(distanciaDestaque).replace('.', ',')} km</span>
							<span className="text-sm opacity-75">{label}</span>
						</div>
					)
				})()}
			</div>
			<div className="flex gap-1 text-blue-600 flex-wrap">
				{servico['s.dataHoraColetar'] && servico['s.dataHoraColetar'] !== '0000-00-00 00:00:00' && (
					<Status
						danger={urgente}
						agendado={servico['s.dataHoraColetar'] != '0000-00-00 00:00:00'}
						texto={<span style={{ fontSize: '0.9rem' }}>{format(parse(servico['s.dataHoraColetar'], 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd/MM HH:mm')}</span>}
						color="#17a2b8"
						fill
					/>
				)}
				{servico['s.dataHoraColetar'] === '0000-00-00 00:00:00' && (
					<Status danger={urgente} texto={<span style={{ fontSize: '0.9rem' }}>AGORA</span>} color="#17a2b8" fill />
				)}
				{servico['s.tipoVecDesc'] && <Status danger={urgente} texto={<span>{servico['s.tipoVecDesc']}</span>} color="#17a2b8" fill />}
			</div>
			{(servico['so.nome'] || servico['so.empresa'] || servico['so.nomeFantasia']) && (
				<div className="flex gap-1 mt-1 flex-wrap">
					{servico['so.nome'] && <Status texto={servico['so.nome']} truncate pop fill />}
					{servico['so.empresa'] && <Status texto={servico['so.empresa']} truncate pop fill />}
					{servico['so.nomeFantasia'] && <Status texto={servico['so.nomeFantasia']} truncate pop fill />}
				</div>
			)}
			{servico['sa.direcao'] && (
				<div className="flex gap-1 mt-1">
					<Status texto={servico['sa.direcao']} truncate pop fill />
				</div>
			)}
			{enderecos.length > 0 && (
				<div className="text-sm mt-1">
					<div className="truncate font-normal" style={{ color: 'var(--primaria-darkest)' }}>{enderecos[0]['e.rua'] || ''}</div>
					{enderecos.length === 2 && (
						<div className="truncate font-normal mt-1" style={{ color: 'var(--primaria-darkest)' }}>{enderecos[1]['e.rua'] || ''}</div>
					)}
					{enderecos.length > 2 && (
						<div className="small flex items-center gap-1 mt-1 opacity-75">
							<Marcador>+{enderecos.length - 1}</Marcador> Endereços
						</div>
					)}
					{servico['s.retorno'] == 'S' && (
						<div className="flex items-center gap-1 small mt-1" style={{ color: 'var(--primaria-darkest)' }}>
							<MdUndo size={18} /> Retorno
						</div>
					)}
				</div>
			)}
		</Card>
	)
}

/** Tipos que exibem distância sem retorno por padrão (quando API não retorna a config). */
const TIPOS_COM_DISTANCIA_SEM_RETORNO = ['AC', 'MC']

/**
 * Obtém exibirDistanciaSemRetorno da config.
 * Valida pelo tipo do SERVIÇO (s.mototaxi), não pelo tipo do profissional.
 * Prioridade: 1) cotação 2) config por tipo do serviço 3) config flat 4) fallback AC/MC.
 */
function getExibirDistanciaSemRetorno(cotacao, configCotacao, dados) {
	const v = cotacao?.exibirDistanciaSemRetorno
	if (v !== undefined) return typeof v === 'object' ? !!v?.exibicao : !!v
	// Tipo do SERVIÇO (s.mototaxi) - prioridade sobre tipo do profissional
	const tipo = cotacao?.["s.mototaxi"] ?? cotacao?.tipoVeiculo ?? cotacao?.siglaTipoVeiculo ?? cotacao?.["s.tipo"] ?? cotacao?.["s.tipoVec"] ?? dados?.siglaTipoVeiculo
	if (tipo && configCotacao?.cotacao?.[tipo]) {
		const valor = configCotacao.cotacao[tipo]?.telaCotacoes?.infoAdicionais?.exibirDistanciaSemRetorno?.exibicao
		if (valor !== undefined) return !!valor
	}
	if (configCotacao?.infoAdicionais?.exibirDistanciaSemRetorno?.exibicao !== undefined)
		return !!configCotacao.infoAdicionais.exibirDistanciaSemRetorno.exibicao
	if (configCotacao?.telaCotacoes?.infoAdicionais?.exibirDistanciaSemRetorno?.exibicao !== undefined)
		return !!configCotacao.telaCotacoes.infoAdicionais.exibirDistanciaSemRetorno.exibicao
	const sigla = tipo || dados?.siglaTipoVeiculo || ''
	return TIPOS_COM_DISTANCIA_SEM_RETORNO.includes(String(sigla).toUpperCase())
}

/**
 * Texto pequeno da "outra" distância (a não-destacada) exibido no header do card.
 * Quando destaqueDistancia == "DV": mostra a distância do serviço (com suporte a sem retorno).
 * Quando destaqueDistancia != "DV" (ex. "DS"): mostra a distância de coleta (até você).
 */
function textoDistanciaSecundaria(cotacao, configCotacao, dados) {
	if (cotacao.destaqueDistancia == "DV") {
		const exibirSemRetorno = getExibirDistanciaSemRetorno(cotacao, configCotacao, dados)
		const dist = exibirSemRetorno
			? (cotacao['s.distanciaSemRetorno'] ?? cotacao['s.distancia'])
			: cotacao['s.distancia']
		if (!dist) return null
		const temSemRetorno = exibirSemRetorno && !!cotacao['s.distanciaSemRetorno']
		const valor = String(dist).replace('.', ',')
		if (cotacao.labelDistancia)
			return <>{cotacao.labelDistancia}: {valor}km{temSemRetorno ? " (sem retorno)" : ""}</>
		return <>percurso: {valor}km{temSemRetorno ? " (sem retorno)" : ""}</>
	}
	if (cotacao['sm.distanciaColeta'])
		return <>Distância de você: {String(cotacao['sm.distanciaColeta']).replace('.', ',') + "km"}</>
	return null
}

/**
 * Obtém exibirDataHoraSolicitacao da config.
 * API retorna estrutura flat: dados.aceitarRecusar.exibirDataHoraSolicitacao
 * Prioridade: 1) cotação 2) config flat (aceitarRecusar) 3) config por tipo 4) default true.
 */
function getExibirDataHoraSolicitacao(cotacao, configCotacao, dados) {
	if (cotacao?.exibirDataHoraSolicitacao !== undefined) return cotacao.exibirDataHoraSolicitacao
	if (!configCotacao) return true
	// Estrutura flat (API /telaCotacoes retorna dados com aceitarRecusar no root)
	const valorFlat = configCotacao.aceitarRecusar?.exibirDataHoraSolicitacao
	if (valorFlat !== undefined) return valorFlat
	// Estrutura aninhada (cotacao.{tipo}.telaCotacoes)
	const tipo = cotacao?.tipoVeiculo ?? cotacao?.siglaTipoVeiculo ?? cotacao?.["s.tipo"] ?? cotacao?.["s.tipoVec"] ?? dados?.siglaTipoVeiculo
	if (tipo && configCotacao.cotacao?.[tipo]) {
		const valor = configCotacao.cotacao[tipo]?.telaCotacoes?.aceitarRecusar?.exibirDataHoraSolicitacao
		if (valor !== undefined) return valor
	}
	return configCotacao.telaCotacoes?.aceitarRecusar?.exibirDataHoraSolicitacao ?? true
}

function renderizarDataHora(cotacao, configCotacao, dados) {
	if (!cotacao || typeof cotacao !== "object") return "AGORA"

	const dataHoraColetar = cotacao["s.dataHoraColetar"]
	const dataEnviado = cotacao["sm.dataEnviado"]
	const formatoEntrada = "yyyy-MM-dd HH:mm:ss"
	const formatoSaida = "dd/MM HH:mm"

	// Trata como "AGORA" quando backend nao enviou agendamento valido.
	if (!dataHoraColetar || dataHoraColetar === "0000-00-00 00:00:00") {
		const exibirDataHora = getExibirDataHoraSolicitacao(cotacao, configCotacao, dados)
		if (exibirDataHora && dataEnviado) {
			const dataSolicitacao = parse(dataEnviado, formatoEntrada, new Date())
			if (isValid(dataSolicitacao)) {
				return format(dataSolicitacao, formatoSaida)
			}
		}
		return "AGORA"
	}

	const dataAgendada = parse(dataHoraColetar, formatoEntrada, new Date())
	if (!isValid(dataAgendada)) return "Data indisponivel"
	return format(dataAgendada, formatoSaida)
}

export default function Cotacoes() {
	const [carregando, setCarregando] = useState(true)
	const [BDLoading, setBDLoading] = useState(false)

	const [exibirFakeGPS, setExibirFakeGPS] = useState(false)
	const [exibirBootClick, setExibirBootClick] = useState(false)

	const { state } = useLocation()

	const [open, setOpen] = useState(false)
	const [anchor, setAnchor] = useState(null)
	const anchorRef = useRef()

	const [menu, setMenu] = useState(false)
	const [BD, setBD] = useState(false)
	const [modal, setModal] = useState(false)
	const [modalMapa, setModalMapa] = useState(false)
	const [posProfMapa, setPosProfMapa] = useState(null)
	const [timeoutMode, setTimeoutMode] = useState(false)
	const [cotacoes, setCotacoes] = useState({})
	const [cotacaoSel, setCotacaoSel] = useState({})

	const [idAtivo, setIdAtivo] = useState(0)
	const [time, setTime] = useState(0)
	const [modo, setModo] = useState(false)
	const [titulo, setTitulo] = useState("")
	const [subTitulo, setSubTitulo] = useState("")

	const [msg, setMsg] = useState(<Spinner />)
	const [valido, setValido] = useState(false)

	const [texto, setTexto] = useState('')
	const [motivo, setMotivo] = useState('')
	const [configRecusar, setConfigRecusar] = useState('')
	const [configCotacao, setConfigCotacao] = useState(null)

	// Estados para vinculação inteligente (zero impacto se aux não existir)
	const [servicosVinculados, setServicosVinculados] = useState([])
	const servicosVinculadosRef = useRef([]) // ref para evitar closure desatualizada no clique
	const [modalVinculacao, setModalVinculacao] = useState(false)
	const [cotacaoSelecionada, setCotacaoSelecionada] = useState(null)
	const [logVinculacao, setLogVinculacao] = useState('') // resumido
	const [logVinculacaoCompleto, setLogVinculacaoCompleto] = useState([]) // array completo para salvar no aceite

	const { dados, setDados } = useContext(ContextoGeral)

	const isTest = useTestChecker(dados.dominio)

	const handleMotivo = (e) => setMotivo(e.target.value)

	async function obterPosicaoProf() {
		let local = { latitude: 0, longitude: 0 }
		try {
			if (window.AndroidInterface && typeof window.AndroidInterface.getLocation === "function") {
				const raw = await window.AndroidInterface.getLocation()
				if (raw && typeof raw === "string") local = JSON.parse(raw)
				else if (raw && typeof raw === "object") {
					local = { latitude: raw.latitude ?? 0, longitude: raw.longitude ?? 0 }
				}
			}
		} catch {
			/* ignore */
		}
		if (window.location.origin.includes("localhost")) {
			local = { latitude: -19.934101, longitude: -44.157393 }
		}
		return local
	}

	async function abrirMapaCotacao(cotacao) {
		const local = await obterPosicaoProf()
		setPosProfMapa(local)
		setCotacaoSel(cotacao)
		setModalMapa(true)
	}

	async function verificarAntifraude() {
		try {
			if (window.AndroidInterface) {
				if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface?.isFakeGPS()) {
					setExibirFakeGPS(true)
				}

				if (dados?.configBootClick && (dados?.configBootClick?.opcao != 'NF' && await verificarBootClick())) {
					setExibirBootClick(true)
				}
			}
		} catch {
			console.error("Não possui esta funcionalidade")
		}
	}

	async function buscarConfigs() {
		let retorno = await ServicoAPI.buscarConfigTelaCotacao(dados)

		if (retorno.resultado && retorno.dados) {
			setTitulo(retorno.dados.titulo != "" ? retorno.dados.titulo : "COTAÇÕES")
			setSubTitulo(retorno.dados.subTitulo ?? "")

			// Guarda toda configuração da tela para controlar, entre outras coisas,
			// a exibição da distância com ou sem retorno.
			setConfigCotacao(retorno.dados)
		} else setTitulo("COTAÇÕES")
	}

	async function buscarCotacoes() {
		let local = { latitude: 0, longitude: 0 }
		try {
			if (window.AndroidInterface && typeof window.AndroidInterface.getLocation === 'function') {
				const raw = await window.AndroidInterface.getLocation()
				if (raw && typeof raw === 'string') local = JSON.parse(raw)
				else if (raw && typeof raw === 'object') local = { latitude: raw.latitude ?? 0, longitude: raw.longitude ?? 0 }
			}
		} catch (e) {
			console.warn('[Cotacoes] Erro ao obter localização do WebView:', e)
		}

		// Fallback para localhost: Betim, MG (API exige la/lo válidos para listar cotações/serviços)
		if (window.location.origin.includes("localhost"))
			local = { latitude: -19.934101, longitude: -44.157393 }

		// Log das coordenadas que serão enviadas (backend exige la/lo válidos para retornar servicosVinculados)
		console.log('[Cotacoes] COORDENADAS enviadas para a API:', { la: local.latitude, lo: local.longitude }, 'origem:', window.location.origin.includes('localhost') ? 'localhost' : (window.AndroidInterface ? 'WebView getLocation()' : 'outro'))
		if (window.AndroidInterface && (Number(local.latitude) === 0 || Number(local.longitude) === 0)) {
			console.warn('[Cotacoes] AVISO: la ou lo estão zerados. No mobileNovo1 a vinculação inteligente SÓ retorna servicosVinculados quando la e lo são enviados e não são zero. Verifique permissão de localização e se o app nativo está passando a posição para getLocation().')
		}

		if ((local == '') || (local.latitude == 0 || local.longitude == 0)) {
			setMsg(MensagemApp.msgErroLaLo)
			setValido(false)
		} else {
			console.log('[Cotacoes] Chamando API buscarCotacoes... dominio:', dados?.dominio, 'idProf:', dados?.idProf, 'la:', local.latitude, 'lo:', local.longitude)
			await ServicoAPI.buscarCotacoes(dados, local).then(res => {
				// === LOG RETORNO API COTAÇÕES (remover depois de debugar) ===
				try {
					console.log('========== COTAÇÕES - RETORNO DA API ==========')
					console.log('Resposta completa (res):', res)
					console.log('Chaves de res:', res ? Object.keys(res) : 'res é null/undefined')
					console.log('res.aux:', res?.aux)
					console.log('res.data (se existir):', res?.data)
					if (res?.aux) {
						console.log('res.aux.servicosVinculados:', res.aux.servicosVinculados)
						console.log('Quantidade servicosVinculados:', Array.isArray(res.aux.servicosVinculados) ? res.aux.servicosVinculados.length : typeof res.aux.servicosVinculados)
					} else {
						console.log('res.aux NÃO EXISTE na resposta')
					}
					console.log('================================================')
				} catch (e) {
					console.error('Erro ao logar retorno cotações:', e)
				}

				// Suporte a resposta no corpo direto ou aninhada em .data (dependendo do backend/proxy)
				const body = res && (res.dados !== undefined || res.resultado !== undefined) ? res : (res?.data || res || {})
				const dadosRes = body.dados !== undefined ? body.dados : res?.dados
				const auxRes = body.aux !== undefined ? body.aux : (res?.aux ?? res?.data?.aux)

				if (body?.resultado ?? res?.resultado) {
					setValido(true)

					if (dadosRes && typeof dadosRes != "string" && typeof dadosRes != "undefined") {
						if (dadosRes.length == 1 && dadosRes[0]?.TEMPOACEITAR) {
							setTime(dadosRes[0]?.TEMPOACEITAR)
							setTimeoutMode(true)
						}

						setMsg(body.mensagem ?? res?.mensagem ?? res?.message)

						if (dadosRes.length == 0 && state && state?.viaNotificacao)
							setMsg("Serviço(os) enviado para outro(os) profissional(ais).")
						setCotacoes(dadosRes)
					} else {
						setCotacoes({})
						if (state && state?.viaNotificacao)
							setMsg("Serviço(os) enviado para outro(os) profissional(ais).")
						else setMsg(body.mensagem ?? res?.mensagem ?? res?.message)
					}

					// Vinculação inteligente: só ativa se aux existir e tiver dados válidos (zero impacto)
					const listaVinculados = auxRes?.servicosVinculados
					const arrVinculados = Array.isArray(listaVinculados)
						? listaVinculados
						: (listaVinculados && typeof listaVinculados === 'object')
							? Object.values(listaVinculados)
							: []
					if (arrVinculados.length > 0) {
						servicosVinculadosRef.current = arrVinculados
						setServicosVinculados(arrVinculados)
						const logResumido = auxRes?.logVinculacaoResumido
						setLogVinculacao(typeof logResumido === 'string' ? logResumido : (logResumido != null ? String(logResumido) : ''))
						const logCompleto = auxRes?.logVinculacao
						setLogVinculacaoCompleto(Array.isArray(logCompleto) ? logCompleto : [])
						if (typeof window !== 'undefined') {
							console.warn('[Cotacoes] Vinculação ativa:', arrVinculados.length, 'vinculado(s). Resposta tinha aux:', !!auxRes, 'keys:', res ? Object.keys(res).join(',') : 'sem res')
						}
					} else {
						servicosVinculadosRef.current = []
						setServicosVinculados([])
						setLogVinculacao('')
						setLogVinculacaoCompleto([])
						if (typeof window !== 'undefined') {
							console.warn('[Cotacoes] Sem vinculação. Resposta keys:', res ? Object.keys(res).join(',') : 'sem res', 'aux:', !!auxRes, 'servicosVinculados:', listaVinculados ? (Array.isArray(listaVinculados) ? listaVinculados.length : 'objeto') : 'não existe')
						}
					}
				} else {
					setValido(true)
					setMsg(MensagemApp.timeout)
					servicosVinculadosRef.current = []
					setServicosVinculados([])
					setLogVinculacao('')
					setLogVinculacaoCompleto([])
				}
			}).catch(rej => {
				console.warn('[Cotacoes] ERRO na API buscarCotacoes:', rej)
				setValido(true)
				setMsg(MensagemApp.timeout)
				servicosVinculadosRef.current = []
				setServicosVinculados([])
				setLogVinculacao('')
				setLogVinculacaoCompleto([])
			})
		}
		setCarregando(false)
	}

	async function confirmar(id, modoSelecionado, motivoRecusar = {}) {
		setBDLoading(false)
		setIdAtivo(id)

		try {
			if (window.AndroidInterface?.recoverVersion() > 100.80) {
				let bloqueio = false

				if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface.isFakeGPS()) {
					setExibirFakeGPS(true)
					bloqueio = dados?.configFakeGPS?.opcao == "B"
				}

				if (dados?.configBootClick && (dados?.configBootClick?.opcao != 'NF' && await verificarBootClick())) {
					setExibirBootClick(true)

					if (!bloqueio)
						bloqueio = dados?.configBootClick?.opcao == "B"
				}

				if (bloqueio) return
			}

			// Vinculação inteligente: ao aceitar, mostrar modal se houver serviços vinculados (usa ref para valor atual)
			const listaVinculadosAgora = servicosVinculadosRef.current || []
			const cotacoesArray = Array.isArray(cotacoes) ? cotacoes : Object.values(cotacoes || {})
			const cotacaoAtual = cotacoesArray.find(c => c && (String(c['s.id']) === String(id) || c['s.id'] == id))
			if (modoSelecionado && listaVinculadosAgora.length > 0 && cotacaoAtual) {
				setCotacaoSelecionada(cotacaoAtual)
				setModalVinculacao(true)
				return
			}

			if (modoSelecionado)
				setTexto(`Você está aceitando o serviço ${id}`)
			else {
				setTexto(`Você está recusando o serviço ${id}`)
				setConfigRecusar(motivoRecusar)
			}

			setModo(modoSelecionado)
			setBD(true)
		} catch (err) {
			console.error(err)
		}
	}

	function calcularValorTotal() {
		const valorPrincipal = parseFloat(cotacaoSelecionada?.['s.valorProfissional'] || cotacaoSelecionada?.['s.valor'] || 0) || 0
		const valorVinculados = (servicosVinculados || []).reduce((total, servico) => {
			return total + (parseFloat(servico['s.valorProfissional'] || servico['s.valor'] || 0) || 0)
		}, 0)
		return (valorPrincipal + valorVinculados).toFixed(2)
	}

	function fecharModalVinculacao() {
		setModalVinculacao(false)
		setCotacaoSelecionada(null)
	}

	function aceitarTodosServicos() {
		fecharModalVinculacao()
		setModo('S')
		setTexto(`Você está aceitando o serviço ${idAtivo} e mais ${servicosVinculados.length} serviço(s) vinculado(s)`)
		setBD(true)
	}

	async function responderCotacao(id, status) {
		try {
			if (window.AndroidInterface?.recoverVersion && window.AndroidInterface.recoverVersion() > 100.80) {
				if (window.AndroidInterface?.isFakeGPS) {

					if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface.isFakeGPS()) {
						setExibirFakeGPS(true)

						if (dados?.configFakeGPS?.opcao == "B")
							return
					}

					if (dados?.configBootClick && (dados?.configBootClick?.opcao != 'NF' && await verificarBootClick())) {
						setExibirBootClick(true)

						if (dados?.configBootClick?.opcao == "B")
							return
					}
				}
			}
		} catch {
			console.error("")
		}

		if (status == 'S' && !dados?.statusOnline) {
			if (typeof window.AndroidInterface !== 'undefined')
				window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroCotacao)
			else
				alert(MensagemApp.msgErroCotacao)

			setBD(false)
		} else {
			setBDLoading(true)
			let data = {
				idProf: dados.idProf,
				idServico: id,
				status: status
			}

			if (modo != 'S') {
				data.motivo = motivo != "" ? motivo : "Expirado"
			}

			let local = {
				latitude: 0,
				longitude: 0
			}

			if (window.AndroidInterface) {
				local = JSON.parse(await window.AndroidInterface.getLocation())
			}

			if (modo == "N" && configRecusar.obrigatorio && motivo.length == 0) {
				if (window.AndroidInterface) window.AndroidInterface.showAndroidVersion("Favor, preencha todos os campos obrigatórios")
			} else {
				const listaVinculadosAgora = servicosVinculadosRef.current || []
				const aceitarVinculados = status === 'S' && listaVinculadosAgora.length > 0

				const retorno = aceitarVinculados
					? await ServicoAPI.responderCotacaoVinculados(
						dados,
						{
							idProf: dados.idProf,
							idsServicos: [id, ...listaVinculadosAgora.map(s => s['s.id'])],
							status: 'S',
							logVinculacaoResumido: logVinculacao || '',
							logVinculacaoCompleto: logVinculacaoCompleto || []
						},
						local
					)
					: await ServicoAPI.responderCotacao(dados, data, local)

				if (retorno?.resultado) {
					window.AndroidInterface?.showAndroidVersion(retorno.mensagem)
					if (aceitarVinculados) {
						servicosVinculadosRef.current = []
						setServicosVinculados([])
						setLogVinculacao('')
						setLogVinculacaoCompleto([])
					}
				} else {
					if (retorno?.mensagem)
						window.AndroidInterface?.showAndroidVersion(retorno.mensagem)
					else
						window.AndroidInterface?.showAndroidVersion(MensagemApp.msgErroApi)
				}

				setBD(false)
				setCarregando(true)
			}
		}

		setMotivo('')
		setBD(false)
	}

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				setOpen(false)

				let json = dados
				json.tutoriais.cotacoes = false
				setDados(json)
			}, 2000)
		}
	}, [open])

	useEffect(() => {
		if (isTest && dados.tutoriais.cotacoes) {
			setTimeout(() => setOpen(true), 1500)
		}

		if (!!window.AndroidInterface) {

			if (window.AndroidInterface.recoverVersion() >= 102.00) {
				window.AndroidInterface.removeNotification(998)
			} else {
				window.AndroidInterface.removeNotification(673)
			}

		}

		if (carregando) buscarCotacoes()
	}, [carregando])

	useEffect(() => {
		const qtd = Array.isArray(cotacoes) ? cotacoes.length : Object.values(cotacoes || {}).length
		if (qtd > 0) {
			setCarregando(false)
		}
	}, [cotacoes])

	useLayoutEffect(() => {
		if (anchorRef) {
			setAnchor(anchorRef)
		}
	}, [anchorRef])

	useEffect(() => {
		verificarAntifraude()
		buscarConfigs()
	}, [])

	useEffect(() => {
		try {
			if (window.AndroidInterface) {
				if (CheckPermission.checkLocationEnabled() && CheckPermission.checkBackgroundLocationAvailable())
					setValido(true)
				else throw "Localização desativada, ative para ver os seus serviços abertos"
			} else {
				if (!window.location.origin.includes("localhost"))
					throw "Não está no celular"
				setValido(true)
			}
		} catch (e) {
			setMsg(e)
			setValido(false)
		}
	})

	return <>
		<motion.div
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
		>
			<TopoMenu voltar="/app/home" titulo={titulo.toUpperCase()} setShow={setMenu} />
			<FakeGpsAlert
				open={exibirFakeGPS}
				setOpen={setExibirFakeGPS}
				opcao={dados?.configFakeGPS?.opcao} />

			<BootClickAlert
				open={exibirBootClick}
				setOpen={setExibirBootClick}
				opcao={dados?.configBootClick?.opcao} />

			{carregando
				? <div className="vh-screen">
					<Spinner />
				</div>
				: <div className="pb-3">
					{subTitulo.length > 0 && <Card className="m-3 text-center p-2">{subTitulo}</Card>}
					{Object.values(cotacoes).length > 0
						? timeoutMode
							? <CotacaoAceitar
								cotacao={cotacoes[0]}
								time={time}
								confirmar={responderCotacao}
								configCotacao={configCotacao}
								dados={dados}
								onVerRota={abrirMapaCotacao}
								reload={() => {
								window.history.replaceState({}, "")
								setCarregando(true)
								}}
							/>
							: <>
								{Object.values(cotacoes).map((cotacao, i) => {
									const urgente = cotacao["s.urgente"] == "S"
									const economico = cotacao["s.freteExpresso"] == "S"

									return <Zoom
										key={"cotacao-" + i}
										in={Object.values(cotacoes).length > 0}
										style={{
											transitionDelay: (Object.values(cotacoes).length > 0) ? i * 200 : 0
										}}
									>
										<Card className={`m-3 p-2 bgGradientGrey ${urgente && 'text-danger'} ${economico && "text-info"}`}>
											{urgente && <div className="bg-danger mb-2 pt-3 text-white" style={{
												margin: "-1rem",
												padding: "0.5rem 1rem"
											}}>
												<div className="flex items-center gap-2">
													<img src={icon} style={{
														height: "1.25rem",
														filter: "brightness(10)"
													}} alt="" />
													Serviço urgente
												</div>
											</div>}

											{economico && <div className="bg-info mb-2 pt-3 text-white" style={{
												margin: "-1rem",
												padding: "0.5rem 1rem"
											}}>
												<div className="flex items-center gap-2">
													<MdMonetizationOn size={24} />
													Serviço econômico
												</div>
											</div>}

											<div className="flex justify-between items-center">
												<div sm={3}>
													<span className=" " style={{ fontWeight: 800, fontSize: "1.25rem", lineHeight: 1, color: urgente ? 'var(--bs-danger)' : economico ? "var(--bs-info)" : 'var(--primaria)' }}>
														#{cotacao['s.id']}
													</span>
												</div>
												<div sm={9} className="flex align-items-end flex-col" style={{
													lineHeight: 1,
													opacity: 0.75,
													fontWeight: 600,
													fontSize: "0.8rem",
													color: urgente ? 'var(--bs-danger)' : economico ? "var(--bs-info)" : 'var(--primaria-darkest)'
												}}>
													{cotacao["s.dataHora"] && <DataHora data={cotacao["s.dataHora"]} />}
													{(() => {
														const t = textoDistanciaSecundaria(cotacao, configCotacao, dados)
														return t ? <div className="font-normal">{t}</div> : null
													})()}
												</div>
											</div>
											<div className="my-1 flex">
												<div className="w-1/2 flex flex-col">
													{(cotacao['s.valor'] || cotacao['s.valorProfissional']) && <div className="mb-0 text-green-600 pb-0">
														<span className=" " style={{ fontSize: "1.75rem", fontWeight: 800 }}>
															{cotacao['s.valor'] == "-"
																? "-"
																: cotacao['s.valor']
																	? new Intl.NumberFormat('pt-BR', {
																		style: 'currency',
																		currency: 'BRL'
																	}).format(cotacao['s.valor'])
																	: new Intl.NumberFormat('pt-BR', {
																		style: 'currency',
																		currency: 'BRL'
																	}).format(cotacao['s.valorProfissional'])}
														</span>
														{cotacao.valorPorKm && <div className="text-xs text-success font-normal">Valor por km: R$ {cotacao.valorPorKm}</div>}
													</div>}

													<div style={{ fontSize: "0.75rem", marginTop: "0rem" }}>
														{cotacao["metodoPag"] && formaPg(cotacao["metodoPag"])}
													</div>
												</div>

																		{cotacao.destaqueDistancia == "DV"
													? cotacao['sm.distanciaColeta'] && <div className="w-1/2 text-end">
														<div className=" " style={{ fontSize: "1.75rem", fontWeight: 600 }}>
															{String(cotacao['sm.distanciaColeta']).replace('.', ',') + "km"}
														</div>
														<div className="text-end font-normal" style={{ fontSize: "0.75rem", marginTop: "3px" }}>
															Distância de você
														</div>
													</div>
													: <div className="w-1/2 text-end">
														{(() => {
															const exibirSemRetorno = getExibirDistanciaSemRetorno(cotacao, configCotacao, dados)
															const distancia = exibirSemRetorno
																? (cotacao['s.distanciaSemRetorno'] ?? cotacao['s.distancia'])
																: cotacao['s.distancia']
															if (!distancia) return null
															const temSemRetorno = exibirSemRetorno && !!cotacao['s.distanciaSemRetorno']
															return (
																<>
																	<div style={{ fontSize: "1.75rem", fontWeight: 600 }}>
																		{String(distancia).replace('.', ',') + "km"}
																	</div>
																	<div className="text-end" style={{ fontSize: "0.75rem", marginTop: "3px" }}>
																		{temSemRetorno ? "Distância do serviço (sem retorno)" : "Distância do serviço"}
																	</div>
																</>
															)
														})()}
													</div>}
											</div>

											<div className="flex gap-1 text-blue-600">
												{cotacao['s.dataHoraColetar'] && <Status
													danger={urgente}
													agendado={cotacao['s.dataHoraColetar'] != "0000-00-00 00:00:00"}
													texto={
														<span style={{ fontSize: "1rem" }}>
															{renderizarDataHora(cotacao, configCotacao, dados)}
														</span>
													}
													color={"#17a2b8"}
													fill />}
												{cotacao["s.tipoVecDesc"] && <Status
													danger={urgente}
													texto={<span>{cotacao["s.tipoVecDesc"]}</span>}
													color={"#17a2b8"}
													fill
												/>}
											</div>

											<div class="flex gap-1 mt-1">
												{cotacao["so.nome"] && <div className="w-full truncate">
													<Status texto={cotacao["so.nome"]} truncate pop fill />
												</div>}
												{cotacao["so.empresa"] && <div className="w-full truncate">
													<Status texto={cotacao["so.empresa"]} truncate pop fill />
												</div>}
												{cotacao["so.nomeFantasia"] && <div className="w-full truncate">
													<Status texto={cotacao["so.nomeFantasia"]} truncate pop fill />
												</div>}
											</div>
											<div className="flex gap-1 mt-1">
												{cotacao['sa.direcao'] && <div className="w-full truncate">
													<Status texto={cotacao['sa.direcao']} truncate pop fill />
												</div>}
											</div>

											{cotacao.enderecos && <div id={i} ref={i === 0 ? anchorRef : null} className="m-0 my-2 flex flex-col" onClick={() => {
												if (cotacao.enderecos) {
													setModal(true)
													setCotacaoSel(cotacao)
												}
											}}>
												<div>
													<div style={{ width: '90%' }}>
														<div>
															<div className="truncate font-normal" style={{ color: "var(--primaria-darkest)", lineHeight: 1 }}>
																{cotacao.enderecos[0]['e.rua']}
															</div>
														</div>

														<div className="relative">
															{cotacao.enderecos?.length == 2
																? <><div
																	className="truncate mt-2 relative font-normal"
																	style={{ color: 'var(--primaria-darkest)' }}
																>
																	{cotacao.enderecos[1]['e.rua']}
																</div>
																	<div className="relative">
																		<div className="flex justify-end mt-1 absolute top-[-35px] right-[-32px]">
																			<MdTouchApp size={22} />
																		</div>
																	</div>
																</>
																: <div className="flex justify-between items-center gap-2 w-full">
																	<div className="flex items-center opacity-50 truncate basis-5/12" style={{ color: 'var(--primaria-darkest)' }}>
																		<div className="small flex items-center">
																			{(cotacao.enderecos?.length - 1) > 1 && (
																				<>
																					<Marcador>
																						+{cotacao.enderecos?.length - 1}
																					</Marcador>
																					Endereços
																				</>
																			)}
																		</div>
																	</div>

																	{cotacao['s.retorno'] == 'S' && <div
																		style={{ color: 'var(--primaria-darkest)' }}
																		className="flex items-center gap-1 small !text-[var(--primaria-darkest)]">
																		<MdUndo size="22" />
																		Retorno
																	</div>}

																	<div className="relative">
																		<div className="flex justify-end mt-1 absolute top-[-25px] right-[-32px]">
																			<MdTouchApp size={22} />
																		</div>
																	</div>
																</div>
															}
														</div>
													</div>
												</div>
												{deveExibirMapaCotacao(cotacao, configCotacao, dados)
													&& pontosMapaCotacao(cotacao.enderecos).length > 0 && (
													<BotaoVerRota onClick={() => abrirMapaCotacao(cotacao)} />
												)}
											</div>
											}

											<Popover
												open={i == 0 && open}
												anchorEl={anchor?.current}
												onClose={() => setOpen(false)}
												anchorOrigin={{
													vertical: 'top',
													horizontal: 'center',
												}}
												transformOrigin={{
													vertical: 'center',
													horizontal: 'center',
												}}
											>
												<Balloon icon={<MdTouchApp size={22} />}>
													Clique nos endereços para ver mais detalhes
												</Balloon>
											</Popover>

											<div className="flex gap-2 mt-2">
												<Button
													color="success"
													startIcon={<MdCheck size={32} />}
													className="w-full"
													onClick={() => { confirmar(cotacao['s.id'], true) }}
												>
													Aceitar
												</Button>
												<Button
													color="error"
													startIcon={<MdCancel size={32} />}
													className="w-full"
													onClick={() => { confirmar(cotacao['s.id'], false, cotacao['motivoRecusar']) }}
												>
													Recusar
												</Button>
											</div>
										</Card>
									</Zoom>
								})
								}
							</>
						: <div className="relative">
							<Alert severity="error" className="mx-3 mt-4 text-center" action={<IconButton onClick={() => setCarregando(true)}>
								<Refresh />
							</IconButton>}>
								{msg}
							</Alert>

						</div>
					}
					{
						!carregando && !valido && <AlertDialog mensagem={{
							titulo: "Ative sua localização!",
							mensagem: "Sua localização está desativada e não será possível aceitar as cotações, ative sua localização para liberar o acesso.",
							opcao: "B"
						}} />
					}
				</div >}
			<MenuLateral show={menu} setShow={setMenu} ativo="0" />
		</motion.div >

		<Backdrop
			sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={modal}
			onClick={() => {
				setModal(false)
			}}
		>
			<Card className="p-3" style={{ width: '90vw', overflow: 'auto', maxHeight: '80vh' }}>
				<h3>#{cotacaoSel['s.id']}</h3>
				<h5 style={{ marginBottom: '-0.8rem' }}>Lista de endereços</h5>
				{Object.keys(cotacaoSel).length > 0 && cotacaoSel.enderecos.map(endereco => {
					return <CardEndereco
						id={endereco['es.ponto']}
						endereco={endereco['e.rua']}
						complemento={endereco['e.complemento']}
						contato={endereco['e.contato']}
						tel={endereco['e.telefone']}
						observacao={endereco['e.observacao'] ?? endereco['e.responsavel']}
						retorno={endereco['e.retorno']}
						recebimento={endereco['e.endPontoReceber']}
						icone
					/>
				})}

				{cotacaoSel['s.pontoReceber'] && <div className='mx-2'>
					<Card className='p-2 small text-white' style={{ backgroundColor: "var(--primaria-darker)" }}>
						<h4 className='text-center fw700'>Observação</h4>
						{cotacaoSel['s.pontoReceber']}
					</Card>
				</div>}

				{deveExibirMapaCotacao(cotacaoSel, configCotacao, dados)
					&& pontosMapaCotacao(cotacaoSel.enderecos).length > 0 && (
					<div className="mt-2 px-1">
						<BotaoVerRota onClick={() => {
							setModal(false)
							abrirMapaCotacao(cotacaoSel)
						}} />
					</div>
				)}
			</Card>
		</Backdrop>

		<MapaCotacaoSheet
			open={modalMapa}
			onClose={() => setModalMapa(false)}
			cotacao={cotacaoSel}
			posProf={posProfMapa}
		/>
		<Backdrop
			sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
			open={BD}
		>
			{BDLoading
				? <div>
					<Spinner />
				</div>
				: <Card className="p-3">
					<h3>Confirme sua solicitação</h3>
					<p className="text-center small">
						{texto}
					</p>
					{(modo === false || modo === 'N') && configRecusar.exibicao && <>
						<label htmlFor="motivo">
							Motivo
							{configRecusar.obrigatorio && <span className="red">
								*
							</span>}
						</label>
						<textarea
							id="motivo"
							value={motivo}
							onChange={handleMotivo}
							className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2"
							placeholder="Digite aqui um motivo de recusa"
						/>
					</>}
					<div className="flex gap-3 mt-3">
						<Button
							color="success"
							variant="contained"
							fullWidth
							onClick={() => { responderCotacao(idAtivo, modo) }}
						>
							Confirmar
						</Button>
						<Button
							color="error"
							variant="text"
							fullWidth
							onClick={() => {
								setMotivo('')
								setBD(false)
							}}
						>
							Cancelar
						</Button>
					</div>
				</Card>}
		</Backdrop>
		<Backdrop
			sx={{ zIndex: (theme) => theme.zIndex.drawer + 3 }}
			open={modalVinculacao}
			onClick={fecharModalVinculacao}
		>
			<Card className="p-3" style={{ width: '95vw', maxHeight: '90vh', overflow: 'auto' }} onClick={e => e.stopPropagation()}>
				<h3 className="mb-2">Serviços vinculados encontrados</h3>
				<p className="small mb-3">
					Ao aceitar este serviço, você também aceitará <strong>{servicosVinculados.length}</strong> serviço(s) adicional(is):
				</p>
				{cotacaoSelecionada && (
					<div className="mb-3">
						<h5 className="small text-success">Serviço principal</h5>
						<ServicoCardVinculacao servico={cotacaoSelecionada} tipo="principal" configCotacao={configCotacao} dados={dados} />
					</div>
				)}
				<div className="mb-3">
					<h5 className="small text-info">Serviços vinculados ({servicosVinculados.length})</h5>
					{servicosVinculados.map(servico => (
						<ServicoCardVinculacao key={servico['s.id']} servico={servico} tipo="vinculado" configCotacao={configCotacao} dados={dados} />
					))}
				</div>
				<div className="bg-success text-white p-2 rounded mb-3 text-center">
					<strong>Total: R$ {calcularValorTotal()}</strong>
				</div>
				<div className="flex gap-2">
					<Button color="success" fullWidth variant="contained" onClick={aceitarTodosServicos}>
						Aceitar todos ({(servicosVinculados.length + 1)} serviços)
					</Button>
					<Button color="error" fullWidth variant="outlined" onClick={fecharModalVinculacao}>
						Cancelar
					</Button>
				</div>
			</Card>
		</Backdrop>
		<FakeGPSBlock />
	</>
}

function DataHora({ data }) {
	try {
		const dataHora = new Date(data)
		return <div>
			{String(dataHora.getDate()).padStart(2, "0")}/{String(dataHora.getMonth() + 1).padStart(2, "0")} {String(dataHora.getHours()).padStart(2, "0")}:{String(dataHora.getMinutes()).padStart(2, "0")}
		</div>
	} catch {
		return <div>
			Data inválida
		</div>
	}
}

function CotacaoAceitar({ cotacao, time, confirmar, configCotacao, dados, reload, onVerRota }) {
	const urgente = cotacao["s.urgente"] == "S"
	const economico = cotacao["s.freteExpresso"] == "S"

	const { faltante, limite } = time

	const [val, setVal] = useState((limite - faltante) / limite)
	const [IDTimer, setIDTimer] = useState(null)
	const [loading, setLoading] = useState(false)
	const [posProf, setPosProf] = useState(null)
	const i = 0
	const anchorRef = useRef()

	const mostrarMapa = deveExibirMapaCotacao(cotacao, configCotacao, dados)
	const pontos = pontosMapaCotacao(cotacao?.enderecos)

	useEffect(() => {
		setVal(1)
		setIDTimer(setTimeout(() => {
			confirmar(cotacao['s.id'], "E")
			setTimeout(() => { reload() }, 1000)
		}, faltante * 1000))
	}, [])

	useEffect(() => {
		if (!mostrarMapa || !pontos.length) return
		let cancelado = false
		;(async () => {
			let local = { latitude: 0, longitude: 0 }
			try {
				if (window.AndroidInterface && typeof window.AndroidInterface.getLocation === "function") {
					const raw = await window.AndroidInterface.getLocation()
					if (raw && typeof raw === "string") local = JSON.parse(raw)
					else if (raw && typeof raw === "object") {
						local = { latitude: raw.latitude ?? 0, longitude: raw.longitude ?? 0 }
					}
				}
			} catch { /* ignore */ }
			if (window.location.origin.includes("localhost")) {
				local = { latitude: -19.934101, longitude: -44.157393 }
			}
			if (!cancelado) setPosProf(local)
		})()
		return () => { cancelado = true }
	}, [mostrarMapa, pontos.length])

	return <>
		{loading
			? <div className="vh-screen">
				<Spinner />
			</div>
			: <div className="vh-screen" style={{
				width: "100vw"
			}}>
				<div className="p-3">
					{urgente && <div className="bg-danger mb-2 pt-3 text-white" style={{
						margin: "-1rem",
						padding: "0.5rem 1rem"
					}}>
						<div className="flex items-center gap-2">
							<img src={icon} style={{
								height: "1.25rem",
								filter: "brightness(10)"
							}} alt="" />
							Serviço urgente
						</div>
					</div>}

					{economico && <div className="bg-info mb-2 pt-3 text-white" style={{
						margin: "-1rem",
						padding: "0.5rem 1rem"
					}}>
						<div className="flex items-center gap-2">
							<MdMonetizationOn size={24} />
							Serviço econômico
						</div>
					</div>}
					<div className="flex justify-between items-center">
						<div sm={3}>
							<span style={{ fontWeight: 800, fontSize: "1.6rem", lineHeight: 1, color: urgente ? 'var(--bs-danger)' : economico ? "var(--bs-info)" : 'var(--primaria)' }}>
								#{cotacao['s.id']}
							</span>
						</div>
						<div sm={9} className="flex align-items-end flex-col" style={{
							lineHeight: 1,
							opacity: 0.75,
							fontWeight: 600,
							fontSize: "0.8rem",
							color: urgente ? 'var(--bs-danger)' : economico ? "var(--bs-info)" : 'var(--primaria-darkest)'
						}}>
							{cotacao["s.dataHora"] && <DataHora data={cotacao["s.dataHora"]} />}
							{(() => {
								const t = textoDistanciaSecundaria(cotacao, configCotacao, dados)
								return t ? <div>{t}</div> : null
							})()}
						</div>
					</div>
					<div className="row my-1">
						<div className="col flex flex-col">
							{(cotacao['s.valor'] || cotacao['s.valorProfissional']) && <div className="mb-0 pb-0">
								<span style={{ fontSize: "2rem", color: "var(--bs-success)", fontWeight: 800 }}>
									{cotacao['s.valor'] == "-"
										? "-"
										: cotacao['s.valor']
											? new Intl.NumberFormat('pt-BR', {
												style: 'currency',
												currency: 'BRL'
											}).format(cotacao['s.valor'])
											: new Intl.NumberFormat('pt-BR', {
												style: 'currency',
												currency: 'BRL'
											}).format(cotacao['s.valorProfissional'])}
								</span>
							</div>}

							<div style={{ fontSize: "0.75rem", marginTop: "-0.5rem" }}>
								{cotacao["metodoPag"] && formaPg(cotacao["metodoPag"])}
							</div>
						</div>

					{cotacao.destaqueDistancia == "DV"
						? cotacao['sm.distanciaColeta'] && <div className="col text-end">
								<div style={{ fontSize: "1.75rem", fontWeight: 600 }}>
									{String(cotacao['sm.distanciaColeta']).replace('.', ',') + "km"}
								</div>
								<div className="text-end" style={{ fontSize: "0.75rem", marginTop: "3px" }}>
									Distância de você
								</div>
							</div>
						: <div className="col text-end">
								{(() => {
									const exibirSemRetorno = getExibirDistanciaSemRetorno(cotacao, configCotacao, dados)
									const distancia = exibirSemRetorno
										? (cotacao['s.distanciaSemRetorno'] ?? cotacao['s.distancia'])
										: cotacao['s.distancia']
									if (!distancia) return null
									const temSemRetorno = exibirSemRetorno && !!cotacao['s.distanciaSemRetorno']
									return (
										<>
											<div style={{ fontSize: "1.75rem", fontWeight: 600 }}>
												{String(distancia).replace('.', ',') + "km"}
											</div>
											<div className="text-end" style={{ fontSize: "0.75rem", marginTop: "3px" }}>
												{temSemRetorno ? "Distância do serviço (sem retorno)" : "Distância do serviço"}
											</div>
										</>
									)
								})()}
							</div>}
					</div>

					{cotacao.valorPorKm && <div className="small text-success">R$ {cotacao.valorPorKm}/km</div>}

					<div className="flex gap-1">
						{cotacao['s.dataHoraColetar'] && <Status
							danger={urgente}
							color="var(--bs-info)"
							agendado={cotacao['s.dataHoraColetar'] != "0000-00-00 00:00:00"}
							texto={
								<span style={{ fontSize: "1rem" }}>
									{renderizarDataHora(cotacao, configCotacao, dados)}
								</span>
							} fill />}
						{cotacao["s.tipoVecDesc"] && <Status
							danger={urgente}
							color="var(--bs-info)"
							texto={<span>{cotacao["s.tipoVecDesc"]}</span>}
							fill
						/>}
					</div>

					<div class="row g-1 mt-0">
						{cotacao["so.nome"] && <div className="truncate">
							<Status texto={cotacao["so.nome"]} truncate pop fill />
						</div>}
						{cotacao["so.empresa"] && <div className="truncate">
							<Status texto={cotacao["so.empresa"]} truncate pop fill />
						</div>}
						{cotacao["so.nomeFantasia"] && <div className="truncate">
							<Status texto={cotacao["so.nomeFantasia"]} truncate pop fill />
						</div>}
					</div>

					{mostrarMapa && pontos.length > 0 && (
						<div className="mt-2 mb-2 overflow-hidden rounded" style={{ border: "1px solid rgba(0,0,0,.08)" }}>
							<div className="flex items-center justify-between px-2 py-1">
								<span className="text-sm font-semibold" style={{ color: "var(--primaria)" }}>
									Rota do serviço · {pontos.length} ponto{pontos.length > 1 ? "s" : ""}
								</span>
								{onVerRota && (
									<button
										type="button"
										className="text-xs font-semibold"
										style={{ color: "var(--primaria)", background: "transparent", border: "none" }}
										onClick={() => onVerRota(cotacao)}
									>
										Ampliar
									</button>
								)}
							</div>
							<MapaCotacaoView
								pontos={pontos}
								posProf={posProf}
								tipoVeiculo={cotacao?.["s.mototaxi"] ?? "M"}
								height="180px"
								open
							/>
						</div>
					)}

					{cotacao.enderecos && <div id={i} ref={i === 0 ? anchorRef : null} className="flex flex-col">
						{Object.keys(cotacao).length > 0 && cotacao.enderecos.map(endereco => {
							return <CardEndereco
								id={endereco['es.ponto']}
								endereco={endereco['e.rua']}
								complemento={endereco['e.complemento']}
								contato={endereco['e.contato']}
								tel={endereco['e.telefone']}
								observacao={endereco['e.observacao'] ?? endereco['e.responsavel']}
								retorno={endereco['e.retorno']}
								recebimento={endereco['e.endPontoReceber']}
								icone
							/>
						})}

						{cotacao['s.pontoReceber'] && <div className='mx-2'>
							<Card className='p-2 small text-white' style={{ backgroundColor: "var(--primaria-darker)" }}>
								<h4 className='text-center fw700'>Observação</h4>
								{cotacao['s.pontoReceber']}
							</Card>
						</div>}
					</div>}
				</div>
				<div style={{
					position: "sticky",
					background: "white",
					width: "100vw",
					bottom: 0
				}}>
					<div className="grid grid-cols-2 gap-2">
						<Button
							color="success"
							startIcon={<MdCheck size={32} />}
							className="w-full min-w-0 whitespace-nowrap overflow-hidden text-ellipsis"
							onClick={() => {
								setLoading(true)
								if (IDTimer) { clearTimeout(IDTimer); setIDTimer(null) }
								confirmar(cotacao['s.id'], true)
							}}
						>
							<span className="block truncate">Aceitar</span>
						</Button>

						<Button
							color="error"
							startIcon={<MdCancel size={32} />}
							className="w-full min-w-0 whitespace-nowrap overflow-hidden text-ellipsis"
							onClick={() => {
								setLoading(true)
								if (IDTimer) { clearTimeout(IDTimer); setIDTimer(null) }
								confirmar(cotacao['s.id'], false, cotacao['motivoRecusar'])
							}}
						>
							<span className="block truncate">Recusar</span>
						</Button>
					</div>

					<div className="relative">
						<div
							style={{
								background: "var(--primaria)",
								width: (val * 100) + "%",
								transition: (faltante * 1000) + "ms linear",
								display: "block",
								height: "8px",
								color: "transparent"
							}}
						/>
					</div>
					<Counter initTime={faltante} desc />
				</div>
			</div>}
	</>
}

function Counter({ initTime, desc }) {
	const [time, setTime] = useState(initTime)
	useEffect(() => {
		if (time > 0) {
			const id = setTimeout(() => setTime(prev => desc ? prev - 1 : prev + 1), 1000)
			return () => clearTimeout(id)
		}
	}, [time])


	return <div className="text-center small" style={{
		color: "var(--primaria)",
		animation: "timer 1s infinite",
		fontSize: "2.2rem",
		fontWeight: 800
	}}>
		{time}
	</div>
}
